import { render, staticRenderFns } from "./pageTitleModule.vue?vue&type=template&id=691cf1b3"
import script from "./pageTitleModule.vue?vue&type=script&lang=js"
export * from "./pageTitleModule.vue?vue&type=script&lang=js"
import style0 from "./pageTitleModule.vue?vue&type=style&index=0&id=691cf1b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports